import React, { useState, useEffect } from 'react';
import { CirclePacking } from '@ant-design/plots';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';

const SecondSaleReport = () => {

    const [modelsSold, setModelsSold] = useState('')
    const [ trigger, setTrigger ] = useState(false)

    useEffect(()=>{
        fetch(`${FetchVariable.Heroku}/sales/get-sales-customer`)
        .then((response) => response.json())
        .then((json) => {            
            setModelsSold(json)
            setTrigger(true)
        })
        .catch((error) => {
            console.log('fetch data failed', error);
        });
    },[])

   const data = []; 
   for (const e of modelsSold) {
        data.push({"name":e.Make + ' ' + e.Model,"value":e.VehiclesSold})
   }

   const SoldModel = () => {
     if(trigger === true) {
      return (
      <CirclePacking {...config} />
      );
     }
     else {
       return null
     }
   }

  
   const config = {
    autoFit: true,
    padding: 10,
    data:{
        "name":"Total Sold",
        "children":data
    },
    sizeField: 'r',
    color: 'rgb(252, 253, 191)-rgb(231, 82, 99)-rgb(183, 55, 121)',
    label: {
      formatter: ({ name }) => {
        return name !== 'Total Sold' ? name : '';
      },
      offsetY: 8,
      style: {
        fontSize: 12,
        textAlign: 'center',
        fill: 'rgba(0,0,0,0.55)',
      },
    },
    legend: false,
  };

  return <SoldModel />;

};

export default SecondSaleReport